import colors from "./color";

export const override = {
    colors: {
        brand: colors.brand,
        dark: colors.dark
    }
}